'use client';

import clickReviewsInOrderBlockSummaryTrigger from '@coolblue-development/ga4-events/triggers/OrderBlockSummary/clickReviewsInOrderBlockSummaryTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useRequestContext } from '@coolblue-development/next-request-context/client';
import { ReviewRating, ReviewsDrawer } from '@coolblue-development/next-reviews/client';
import { Product } from '@features/product/typings';
import { MainProduct } from '@features/second-chance/typings';
import { ReactNode, useState } from 'react';

type ProductReviewRatingProps = {
  product: Product | MainProduct;
  salesPriceComponent: ReactNode;
  writeReviewLink?: string;
  productId: number;
};

export default function ProductReviewRating({
  product,
  salesPriceComponent,
  writeReviewLink,
  productId
}: ProductReviewRatingProps) {
  const [showDrawer, setShowDrawer] = useState(false);
  const { language } = useRequestContext();
  const { trackEvent } = useAnalytics();

  const onReviewClick = () => {
    const params = {
      item_id: productId
    };

    trackEvent(clickReviewsInOrderBlockSummaryTrigger(params));
    setShowDrawer(true);
  };

  return (
    <>
      <ReviewRating
        onClick={() => {
          onReviewClick();
        }}
        writeReviewLink={writeReviewLink || '#'}
        scoreDisplay='none'
        value={product.reviewMetaData?.averageRating ?? 0}
        reviewCount={product.reviewMetaData?.count ?? 0}
        size='medium'
        isOwnedByCustomer={false} // TODO: to be passed from super graph
      />

      {showDrawer && (
        <ReviewsDrawer
          productInfo={{
            fullName: product.name,
            url: product.urls?.product || '',
            id: product.id,
            imageId: product.primaryImage?.id || ''
          }}
          lang={language}
          isOpen={showDrawer}
          setIsOpen={setShowDrawer}
          salesPriceComponent={salesPriceComponent}
        />
      )}
    </>
  );
}
